<template>
  <validation-provider
    :disabled="!validatable"
    :name="fieldName || label"
    :rules="validatable ? preparedRules : ''"
    :vid="vid"
    v-slot="validationContext"
    slim
  >
    <b-form-group
      v-bind="$attrs"
      :state="getValidationState(validatable, validationContext)"
      :label-cols-sm="noLabel ? undefined : labelColsSm"
      :class="controlClass"
      :label-class="labelClass"
    >
      <template slot="label">
        <div>
          {{ noLabel ? undefined : fieldLabel }}
          <base-help-icon :help-description="helpDescription" />
        </div>
      </template>
      <slot>
        <b-input-group
          :class="getValidationClass(validatable, validationContext)"
        >
          <b-form-input
            :value="preparedValue"
            :disabled="disabled"
            type="text"
            :placeholder="$t('common.time_placeholder')"
            :state="getValidationState(validatable, validationContext)"
            @keydown="checkInputValue"
            @input="emitValue"
          />
          <b-input-group-append>
            <b-form-timepicker
              :disabled="disabled"
              :value="preparedValue"
              @input="emitValue"
              right
              button-only
              :hour12="false"
              minutes-step="10"
              hide-header
              v-bind="$t('time_picker')"
              :locale="$i18n.locale"
            >
              <template #button-content>
                <base-icon icon="clock" fixed-width />
              </template>
            </b-form-timepicker>
          </b-input-group-append>
        </b-input-group>
        <b-form-invalid-feedback
          v-if="validatable"
          :state="getValidationState(validatable, validationContext)"
        >
          {{ validationContext.errors[0] }}
        </b-form-invalid-feedback>
      </slot>
    </b-form-group>
  </validation-provider>
</template>

<script>
import { baseValidatableMixin } from "@foys-tech/foys-utils";
import { BaseHelpIcon, BaseIcon } from "./";
export default {
  mixins: [baseValidatableMixin],
  components: { BaseHelpIcon, BaseIcon },
  props: {
    validatable: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: Object | String,
      default: null,
    },
  },
  data() {
    return {
      timeFormat: "hh:mm",
      timeRegex: /^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/,
    };
  },
  computed: {
    preparedRules() {
      return this.rules
        ? this.rules
        : {
            required: this.required,
            regex: this.timeRegex,
          };
    },
    preparedValue() {
      if (!this.value) {
        return "";
      }
      if (this.value.length <= this.timeFormat) {
        return this.value;
      }
      return this.value.substring(0, 5);
    },
  },
  methods: {
    checkInputValue($event) {
      if (
        this.value &&
        (($event.key == ":" && this.value.endsWith(":")) ||
          ($event.target.value.length == this.timeFormat.length &&
            $event.key != "Backspace" &&
            $event.key != "Tab"))
      ) {
        $event.preventDefault();
      }
    },
    processInput(val) {
      if (!val) {
        return null;
      }

      if (val.length < this.timeFormat.length) {
        if (
          val &&
          val.endsWith(":") &&
          val.length == 3 &&
          this.value.length == 4
        ) {
          //Remove colon
          val = val.substring(0, val.length - 1);
        } else if (
          val &&
          !val.endsWith(":") &&
          val.length == 2 &&
          this.value.length == 1
        ) {
          //Add colon
          val = val + ":";
        }
      }

      if (val.length > this.timeFormat.length) {
        val = val.substr(0, 5);
      }

      return val;
    },
  },
};
</script>